import * as React from 'react';
import { Transition } from 'react-transition-group';

import { VALID_TRANSITION_STATES } from '../../../Animations/Animations';
import { isOutsideClick, watchKeyboardClose } from '../../../Utils/events/events';
import { useEventListener } from '../../../Utils/Hooks/events/useEventListener';
import { useTransitionEnded } from '../../../Utils/Hooks/events/useTransitionEnded';
import { IHeaderDropdownCommon } from '../common';

import { StyledDrawer } from './StyledHeaderDrawer';

export const TRANSITION_DURATION: number = 200;

type IHeaderDropdown = IHeaderDropdownCommon & React.HTMLAttributes<HTMLUListElement>;

const HeaderDrawer: React.FC<IHeaderDropdown> = ({ isOpen, closeDrawer, children, ...rest }) => {
  const drawerRef = React.useRef<HTMLUListElement | null>(null);
  const { contentHasTransitioned, transitionEndListener } = useTransitionEnded(isOpen);

  useEventListener('click', e => isOpen && contentHasTransitioned && isOutsideClick(drawerRef, e as MouseEvent) && closeDrawer());

  const setRef = React.useCallback(
    node => {
      if (node !== null) {
        drawerRef.current = node;
      }
    },
    []
  );

  useEventListener('keydown', watchKeyboardClose(drawerRef, closeDrawer));

  return (
    <Transition
      in={isOpen}
      timeout={{
        appear: 0,
        enter: 0,
        exit: TRANSITION_DURATION,
      }}
      addEndListener={transitionEndListener}
    >
      {(state: VALID_TRANSITION_STATES) => (
        state === VALID_TRANSITION_STATES.exited ? null : (
          <StyledDrawer ref={setRef} transitionState={state} {...rest}>
            {children}
          </StyledDrawer>
        )
      )}
    </Transition>
  );
};

export default HeaderDrawer;
